import { getBrowserClient } from '@repo/supabase-client';
import type { FunctionInvokeOptions } from '@supabase/supabase-js';
import { config } from './config';
import { dropStaleOAuthErrorFromUrl } from './oauthCallbackReplay';

// Before the client exists: a replayed OAuth error in the address bar would
// otherwise make auth-js drop the session it is about to load (YAR-438 QA —
// Back from the Founder's letter signed the parent out). The guard only acts
// when a session is already persisted; see lib/oauthCallbackReplay.ts. No
// breadcrumb here — this module evaluates before main.tsx's initSentry(),
// so AuthContext reports the drop instead.
dropStaleOAuthErrorFromUrl(config.supabaseUrl!);

// validateConfig guarantees these fields are defined (schema has .default()),
// but tsc -b infers them as string | undefined through the built .d.ts.
export const supabase = getBrowserClient({
  url: config.supabaseUrl!,
  anonKey: config.supabaseAnonKey!,
});

/**
 * Invoke a Supabase Edge Function with a fresh access token.
 *
 * `supabase.functions.invoke()` uses the cached token which may be expired.
 * The Supabase gateway rejects expired JWTs before the function code runs.
 * Calling `getSession()` first forces the client to refresh if needed.
 */
export async function invokeFunction(
  name: string,
  options?: FunctionInvokeOptions,
) {
  await supabase.auth.getSession();
  return supabase.functions.invoke(name, options);
}
